// extracted by mini-css-extract-plugin
export default {"selectbox_head":"styles_selectbox_head__GaC7H","selectbox_list":"styles_selectbox_list__wF9ns"};